export default {
  icon: {
    width: 14,
  },
};
